import { addDays } from 'date-fns';
import { Tjenestetype } from '../types/helsetilbud';
import { shortDate } from '@helsenorge/core-utils/date-fns-utils';
import { format } from '@helsenorge/core-utils/string-utils';
export function mapTidsperioderToFravaerDatoer(isFravaer) {
    const fravaerDatoer = {};
    if (isFravaer && isFravaer.tidsperioder) {
        isFravaer.tidsperioder.forEach(tidsperiode => {
            tidsperiode.tjenestetyper?.forEach(tjenestetype => {
                switch (tjenestetype) {
                    case Tjenestetype.ekontakt:
                        fravaerDatoer.ekontakt = tidsperiode.tilOgMedDato;
                        break;
                    case Tjenestetype.ekonsultasjon:
                        fravaerDatoer.ekonsultasjon = tidsperiode.tilOgMedDato;
                        break;
                    case Tjenestetype.timebestilling:
                        fravaerDatoer.timebestilling = tidsperiode.tilOgMedDato;
                        break;
                    case Tjenestetype.reseptfornyelse:
                        fravaerDatoer.reseptfornyelse = tidsperiode.tilOgMedDato;
                        break;
                }
            });
        });
    }
    return fravaerDatoer;
}
export const getFravaerTekst = (dato, resourcesText) => {
    return format(resourcesText, [shortDate(addDays(new Date(dato), 1))]);
};
